export type ArticleStatus = 'planned' | 'drafting' | 'published';

export type Article = {
  slug: string;
  title: string;
  dek: string;
  status: ArticleStatus;
  topic: string;
  readTime: string;
  disclosure: string;
  href?: string;
};

export const articles: Article[] = [
  {
    slug: 'operating-canvas',
    title: 'The Operating Canvas: eight lenses on one business',
    dek: 'The Business Model Canvas tells you what a business is. The Operating Canvas tells you how one actually runs.',
    status: 'published',
    topic: 'Operating frame',
    readTime: '6 min read',
    disclosure:
      'May use AI-assisted research, outlining, drafting, and editing. Final claims remain JL-reviewed.',
    href: '/articles/operating-canvas',
  },
  {
    slug: 'cash-clarity-before-automation',
    title: 'Cash clarity before automation',
    dek: 'A practical note on why finance workflows should be mapped before software is built around them.',
    status: 'planned',
    topic: 'Finance workflow',
    readTime: 'Future note',
    disclosure:
      'May use AI-assisted research, outlining, drafting, and editing before final human review.',
  },
  {
    slug: 'what-ai-should-not-touch-in-finance-work',
    title: 'What AI should not touch in finance work',
    dek: 'A public boundary piece on judgment, review, privacy, and where human responsibility stays close to the books.',
    status: 'drafting',
    topic: 'AI judgment',
    readTime: 'Starter draft',
    disclosure:
      'May use AI-assisted structure and editing; claims and final wording remain JL-reviewed.',
  },
];
